<template>
    <div id="world_map"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core"
import * as am4maps from "@amcharts/amcharts4/maps"
import am4geodata_worldHigh from "@amcharts/amcharts4-geodata/worldHigh"

export default {
mounted() {
let map = am4core.create("world_map", am4maps.MapChart)
map.geodata = am4geodata_worldHigh
map.projection = new am4maps.projections.Miller()

var polygonSeries = map.series.push(new am4maps.MapPolygonSeries())
// Make map load polygon (like country names) data from GeoJSON
polygonSeries.useGeodata = true
// Configure series
var polygonTemplate = polygonSeries.mapPolygons.template;
polygonTemplate.tooltipText = "{name}";
polygonTemplate.polygon.fillOpacity = 0.6;

// Create hover state and set alternative fill color
var hs = polygonTemplate.states.create("hover");
hs.properties.fill = map.colors.getIndex(0);
// Exclude Antartica
polygonSeries.exclude = ["AQ"];

polygonSeries.mapPolygons.template.events.on("hit", function(ev) {
map.zoomToMapObject(ev.target)
})
},
beforeDestroy() {
    if (this.map) {
    this.map.dispose()
    }
}
}
</script>

<style lang="scss" scoped>
#world_map {
  width: 100%;
  height: 100%;
}
</style>